<template>
  <div class="window-of-activity">
    <div class="content">
      <div class="itemDiv">
        <div class="bannerDiv">

        <div>
<div >
  <el-carousel height="409px">
      <el-carousel-item v-for="chartItem in chartList" :key="chartItem.id">
        <img :src="chartItem.img_url" class="windowImg"  alt="">
      </el-carousel-item>


    </el-carousel>
</div>

        </div>
      </div>
      <!-- <div class="w50" >
        <div class="windowOf1Header">
          <div class="windowOf1Img">
            <img src="@/assets/windowOf2.png" alt="">
          </div>
          <div class="headTitle blackTitle" @click="goToNews">
            动态新闻
          </div>
        </div>
        <div class="newsItem" v-for="newsItem in newsList" @click="goToNewsDetail(newsItem.id)">
          <div class="newsItemLeft">
          <div class="dot"></div>
          <el-tooltip class="item" effect="dark" :content="newsItem.title" placement="top-start">
            <div class="newsTitle">{{newsItem.title}}</div>

    </el-tooltip>
        </div>
        <div class="newsTitle">{{newsItem.add_date}}</div>
        </div>
 
      </div> -->
        <div >

    <div class="newsContent">
      <div class="noticeContentTop">
      <div class="noticeContentTopMore">
      <img src="@/assets/hdzcTitleBg.png" class="homeNoticeImg" />
      </div>
      <div class="noticeContentTopMore" @click="goToNews">
      <div class="homeNoticeMore">查看更多</div>
      <div>
      <img src="@/assets/homeRightArr.png" class="homeRightArr" />
      </div>
      </div>
      </div>

      <div class="noticeContentList" v-for="(notice,index) in newsList" :key="index"  @click="goToNewsDetail(notice.id)">
      <div class="noticeTitle">{{notice.title}}</div>
      <div class="newsTitle">{{notice.add_date}}</div>
      </div>
    </div>
  </div>
      <!-- <div class="w50">
        <div class="windowOf1Header">
          <div class="windowOf1Img">
            <img src="@/assets/windowOf3.png" alt="">
          </div>
          <div class="headTitle blackTitle" @click="goToNotice">
            通知公告
          </div>
        </div>
        <div class="noticeDiv" v-for="noticeItem in noticeList" @click="goToNoticeDetail(noticeItem.id)">
          <div class="noticeItem">
            <div class="dot"></div>
            <el-tooltip class="item" effect="dark" :content="noticeItem.title" placement="top-start">
            <div class="newsTitle">{{noticeItem.title}}</div>
    </el-tooltip>
          </div>
          <div class="noticeDate">{{noticeItem.add_date}}</div>
        </div>
      </div> -->

      </div>

      
  <div class="announcementDiv">

    <div class="announcementContent">
      <div class="noticeContentTop">
      <div class="noticeContentTopMore">
      <img src="@/assets/homeNoticeImg.png" class="homeNoticeImg" />
      </div>
      <div class="noticeContentTopMore" @click="goToNotice">
      <div class="homeNoticeMore">查看更多</div>
      <div>
      <img src="@/assets/homeRightArr.png" class="homeRightArr" />
      </div>
      </div>
      </div>

      <div class="announcementList" v-for="(notice,index) in noticeList" :key="index" @click="goToNoticeDetail(notice.id)">

      <div class="noticeLeft">
            <div class="circle"></div>
      <div class="announcementTitle">{{notice.title}}</div>
      </div>

      <div>
      <div class="announcementDate">{{notice.add_date}}</div>
      </div>

      </div>
    </div>
  </div>

  <div class="listContent">
<div class="mb30 fileDiv">
<div >
<img src="@/assets/homeFile.png" class="homeNoticeImg" alt="">
</div>
      <div class="noticeContentTopMore" @click="goTofileDownload">
      <div class="homeNoticeMore">查看更多</div>
      <div>
      <img src="@/assets/homeRightArr.png" class="homeRightArr" />
      </div>
      </div>
</div>

<div class="fileListDiv">
<div class="fileListContent" v-for="(file,index) in fileDownloadList" :key="index" @click="goToFileDownloadDetail(file.id)">
<div>
<img :src="getFileIcon(file.file_type)" class="homePdfImg" alt="">
</div>
<div>
<div class="fileTitle">{{file.title}}</div>
<div class="fileRemark">文件大小：{{file.file_size}} <span class="m5">更新时间：{{file.up_date}}</span>    下载次数：{{file.download_count}}</div>
</div>
<div>
<img src="@/assets/homeDown.png" class="homeDownImg" alt="">
</div>
</div>
</div>

</div>
    </div>
  </div>
</template>

<script>

export default {
  name: "WindowOfActivity",
  data(){
    return {
      newsList: [],
      noticeList: [],
      fileDownloadList: [],
      chartList: [],
       homeData:{}
    }
  },
    computed: {
    getFileIcon() {
      return (type) => type === 'pdf' ? require('@/assets/homePdf.png') : require('@/assets/homeWord.png');
    }
  },
  mounted(){
    // this.getHomeData();
    this.getNewsListData();
    this.getNoticeList();
    this.getFileDownloadList();
    this.getChartListData();
  },
  methods: {
        getHomeData(){
      this.$API.getHomeList().then(res => {
        this.homeData = res.data
    })
    },
    getChartListData(){
      this.$API.getChartList({
        type: 2,
      }).then(res => {
        this.chartList = res.data.list;
      });
    },
    goToNewsDetail(id){
      this.$router.push({ path: "/NewsDetail", query: { id: id }});
    },
    goToNoticeDetail(id){
      this.$router.push({ path: "/NoticeDetail", query: { id: id }});
    },
    goToFileDownloadDetail(id){
      this.$router.push({ path: "/FileDownloadDetail", query: { id: id }});
    },
    getNewsListData(){
      this.$API.getNewsList({
        identify: 1,
        pageSize: 6,
        currPage: 1
      }).then(res => {
        this.newsList = res.data.list;
        console.log(res);
      });
    },
    getNoticeList(){
      this.$API.getNewsList({
        identify: 2,
        pageSize: 6,
        currPage: 1
      }).then(res => {
        this.noticeList = res.data.list;
        console.log(res);
      });
    },
    getFileDownloadList(){
      this.$API.getNewsList({
        identify: 3,
        pageSize: 6,
        currPage: 1
      }).then(res => {
        this.fileDownloadList = res.data.list;
        console.log(res);
      });
    },
    goToNews(){
      this.$router.push({ path: "/News"});
    },
    goToNotice(){
      this.$router.push({ path: "/Notice"});
    },
    goTofileDownload(){
      this.$router.push({ path: "/FileDownload"});
    }
  }

};
</script>

<style scoped lang="scss">
.fileListContent:nth-child(2n){
  margin-left: 30px;
}
.homePdfImg{
  width: 38px;
  height: 50px;
}
.homeDownImg{
  width: 46px;
  height: 46px;
} 
.fileDiv{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
}
.m5{
  margin: 0 12px;
}
.fileListDiv{
  display: flex;
  flex-wrap: wrap;
}
.fileRemark{
  width: 396px;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #999999;
margin-top: 10px;
}
.fileTitle{
  width: 405px;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 16px;
color: #444444;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}
.mb30{
  margin-bottom: 30px;
}
.fileListContent{
  width: 585px;
height: 110px;
background: #FFFFFF;
box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.08);
border-radius: 4px 4px 4px 4px;
display: flex;
justify-content: space-between;
align-items: center;
padding: 30px 24px;
margin-bottom: 20px;
cursor: pointer;
}
.announcementDiv{
  margin-top: 40px;
}

.noticeLeft{
  display: flex;
  align-items: center;
}
::v-deep .el-carousel__button{
  height: 6px !important;
  width: 30px !important;
background: #FFFFFF;
border-radius: 4px 4px 4px 4px;
}
::v-deep .el-icon-arrow-left{
  color: #000 !important;
}
::v-deep .el-icon-arrow-right{
  color: #000 !important;
}
::v-deep .el-carousel__arrow{
  background: #fff !important;
}
.announcementList{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom: 1px solid #EEEEEE;
  color: #444444;
  cursor: pointer;
  &:hover{
  color: #0366F1 !important;
}

}

.noticeDiv{
  border-bottom: 1px solid #ddd;
  padding-bottom: 15px;
  cursor: pointer;

}
.noticeDate{
  font-size: 16px;
    color: #999;
    line-height: 16px;
    margin-left: 10px;
    margin-top: 14px;
}
.noticeItem{
  display: flex;
  align-items: center;
  margin-top: 15px;

}
.newsItemLeft{
  display: flex;
  align-items: center;
  width: 80%;
  flex-shrink: 0;

}
.newsItemLeft .newsTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;

}

.newsItem{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  padding-top: 8px;
}
.newsTitle{
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dot{
  width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #2f86ff;
    display: inline-block;
    margin-right: 6px;
    
}
.blackTitle{
  color: #666666 !important;
  cursor: pointer;
}
.itemDiv{
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.windowImg{
  width: 100%;
  height: 100%;
}
.headTitle{
  color: #000;
    font-size: 22px;
    font-weight: 500;
}
.windowOf1Img{
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.windowOf1Header{
  display: flex;
  align-items: center;
}
.bannerDiv{
    width: 585px;
    height: 409px;
    border-radius: 4px;
}
.window-of-activity {
  min-height: 500px;
    position: relative;
    z-index: 2;
    overflow: hidden;
    background: #fff;
      min-height: calc(100vh - 230px);
}
.content {
     width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;

}

.noticeTitle{
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;



font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
line-height: 24px;
cursor: pointer;

}
.noticeContentList{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom: 1px solid #EEEEEE;
  color: #444444;
  &:hover{
  color: #0366F1 !important;
}
}

 .circle{
  flex-shrink: 0;
  margin-right: 10px;
}

.circle{
  width: 4px;
height: 4px;
background: #ACACAC;
border-radius: 50%;
}
.noticeContentTop{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.homeNoticeMore{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #2F86FF;
margin-right: 5px;
cursor: pointer;
}
.noticeContentTopMore{
  display: flex;
  align-items: center;
}
.homeRightArr{
  width: 7px;
  height: 12px;
}
.homeNoticeImg{
  width: 110px;
  height: 29px;
}
.newsContent{
width: 595px;
height: 409px;
background: linear-gradient( 359deg, #FFFFFF 0%, #EDF5FF 100%);
box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.05);
border-radius: 4px 4px 4px 4px;

padding: 20px;
}
</style>
